import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPictoParticulierVoirDetail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 4.5C6.75 4.5 2.16 8.09 0.5 12C2.16 15.91 6.75 19.5 12 19.5C17.25 19.5 21.84 15.91 23.5 12C21.84 8.09 17.25 4.5 12 4.5ZM12 5.25C16.88 5.25 21.16 8.52 22.72 12C21.16 15.48 16.88 18.75 12 18.75C7.12 18.75 2.84 15.48 1.28 12C2.84 8.52 7.12 5.25 12 5.25Z",
			fill: "#1E1E1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 7.75C14.35 7.75 16.25 9.65 16.25 12C16.25 14.35 14.35 16.25 12 16.25C9.65 16.25 7.75 14.35 7.75 12C7.75 9.65 9.65 7.75 12 7.75Z",
			fill: "#1E1E1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.5C10.62 9.5 9.5 10.62 9.5 12C9.5 13.38 10.62 14.5 12 14.5C13.38 14.5 14.5 13.38 14.5 12C14.5 10.62 13.38 9.5 12 9.5ZM12 10.25C12.97 10.25 13.75 11.03 13.75 12C13.75 12.97 12.97 13.75 12 13.75C11.03 13.75 10.25 12.97 10.25 12C10.25 11.03 11.03 10.25 12 10.25Z",
			fill: "#2188E5"
		})
	]
});
export default SvgPictoParticulierVoirDetail;
